import revive_payload_client_4sVQNw7RlN from "/home/runner/work/wow-guide/wow-guide/frontend-wg3/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import unhead_KgADcZ0jPj from "/home/runner/work/wow-guide/wow-guide/frontend-wg3/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "/home/runner/work/wow-guide/wow-guide/frontend-wg3/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import payload_client_yVLowv6hDl from "/home/runner/work/wow-guide/wow-guide/frontend-wg3/node_modules/nuxt/dist/app/plugins/payload.client.js";
import check_outdated_build_client_8vK7RkfGxZ from "/home/runner/work/wow-guide/wow-guide/frontend-wg3/node_modules/nuxt/dist/app/plugins/check-outdated-build.client.js";
import plugin_vue3_A0OWXRrUgq from "/home/runner/work/wow-guide/wow-guide/frontend-wg3/node_modules/@pinia/nuxt/dist/runtime/plugin.vue3.mjs";
import components_plugin_KR1HBZs4kY from "/home/runner/work/wow-guide/wow-guide/frontend-wg3/.nuxt/components.plugin.mjs";
import prefetch_client_5tzzN0oIVL from "/home/runner/work/wow-guide/wow-guide/frontend-wg3/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import chunk_reload_client_UciE0i6zes from "/home/runner/work/wow-guide/wow-guide/frontend-wg3/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import plugin_1UohGbtF8v from "/home/runner/work/wow-guide/wow-guide/frontend-wg3/node_modules/@pinia-plugin-persistedstate/nuxt/dist/runtime/plugin.mjs";
import lifecycle_client_uGCXBOfp9m from "/home/runner/work/wow-guide/wow-guide/frontend-wg3/plugins/lifecycle.client.ts";
export default [
  revive_payload_client_4sVQNw7RlN,
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  payload_client_yVLowv6hDl,
  check_outdated_build_client_8vK7RkfGxZ,
  plugin_vue3_A0OWXRrUgq,
  components_plugin_KR1HBZs4kY,
  prefetch_client_5tzzN0oIVL,
  chunk_reload_client_UciE0i6zes,
  plugin_1UohGbtF8v,
  lifecycle_client_uGCXBOfp9m
]